import { openDB } from "idb";
export const SchemaSyncHandler = {
  sync() {
    openDB("AIRWAYS3idb", 1, {
      upgrade(db) {
        //production
        if (!db.objectStoreNames.contains("tbSettings")) {
          db.createObjectStore("tbSettings");
        }
        if (!db.objectStoreNames.contains("tbRandomisation")) {
          db.createObjectStore("tbRandomisation", {
            keyPath: "id",
            autoIncrement: true,
          });
        }
        if (!db.objectStoreNames.contains("tbPostRandCRF")) {
          db.createObjectStore("tbPostRandCRF");
        }
        /*
        //testing and database reset
        if (db.objectStoreNames.contains("tbSettings")) {
          db.deleteObjectStore("tbSettings");
        }
        db.createObjectStore("tbSettings");

        if (db.objectStoreNames.contains("tbRandomisation")) {
          db.deleteObjectStore("tbRandomisation");
        }
        db.createObjectStore("tbRandomisation", {
          keyPath: "id",
          autoIncrement: true,
        });
        if (db.objectStoreNames.contains("tbPostRandCRF")) {
          db.deleteObjectStore("tbPostRandCRF");
        }
        db.createObjectStore("tbPostRandCRF");
        */
      },
    });
  },
};
